module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page) ? _c('main', {
    staticClass: "page-content"
  }, [_c('hero', {
    attrs: {
      "page": _vm.page
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "categories container"
  }, [_c('h2', [_vm._v("Categories")]), _vm._v(" "), _c('ul', _vm._l((_vm.page.resources), function(category) {
    return _c('li', [_c('a', {
      attrs: {
        "href": _vm._f("toSlug")('#' + category.category)
      }
    }, [_vm._v(_vm._s(category.category))])])
  }))]), _vm._v(" "), _c('section', _vm._l((_vm.page.resources), function(category) {
    return _c('div', {
      staticClass: "resources-list container",
      attrs: {
        "id": _vm._f("toSlug")(category.category)
      }
    }, [_c('h3', [_vm._v(_vm._s(category.category))]), _vm._v(" "), _c('ul', _vm._l((category.resources), function(item) {
      return _c('li', [_c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        },
        domProps: {
          "innerHTML": _vm._s(item.link_text)
        }
      })])
    }))])
  }))], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57cf34bd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources.vue
// module id = 782
// module chunks = 1